import MasterDataPage from "../common/MasterDataPage"
import { competitionsApi } from "../../../service/certificate"

const CATEGORY_OPTIONS = [
  { value: "Academic", label: "Academic" },
  { value: "Arts", label: "Arts" },
  { value: "Sports", label: "Sports" },
  { value: "Other", label: "Other" },
]

const CertCompetitions = () => (
  <MasterDataPage
    config={{
      title: "Competitions",
      subtitle: "School-wide reusable activities (Quiz, Debate, Science Fair, …). Used when generating Participation certificates.",
      api: competitionsApi as any,
      columns: [
        { title: "Name", dataIndex: "name" },
        { title: "Category", dataIndex: "category", render: (v: string) => v || "—" },
        { title: "Description", dataIndex: "description", render: (v: string) => v || "—" },
      ],
      toolbarFilters: [
        { name: "category", placeholder: "All categories", options: CATEGORY_OPTIONS },
      ],
      defaultValues: { category: "Academic" },
      fields: [
        { name: "name", label: "Name", required: true, placeholder: "e.g. Inter-School Debate Competition" },
        { name: "category", label: "Category", type: "select", options: CATEGORY_OPTIONS },
        { name: "description", label: "Description", type: "textarea", placeholder: "Optional — shown when picking competitions in the generator" },
      ],
    }}
  />
)

export default CertCompetitions
